module.exports = __webpack_public_path__ + "img/c00_buildingtechpickaxe_Normal_ua.edef0c41.webp";